/** Formatações pt-BR do painel. Números grandes viram "mi"/"mil" para caber no card. */

export function moeda(valor: number): string {
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  })
}

export function moedaCompacta(valor: number): string {
  const abs = Math.abs(valor)
  if (abs >= 1_000_000) {
    return `R$ ${(valor / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 2 })} mi`
  }
  if (abs >= 10_000) {
    return `R$ ${(valor / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })} mil`
  }
  return moeda(valor)
}

export function percentual(fracao: number, casas = 1): string {
  return `${(fracao * 100).toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  })}%`
}

export function inteiro(valor: number): string {
  return valor.toLocaleString('pt-BR')
}

/** `2026-06-01T03:00:00Z` → `01/06/2026`, sempre em horário de Brasília. */
export function dataCurta(iso: string): string {
  const brt = new Date(new Date(iso).getTime() - 3 * 60 * 60 * 1000)
  const [ano, mes, dia] = brt.toISOString().slice(0, 10).split('-')
  return `${dia}/${mes}/${ano}`
}

/** `2026-06` → `junho de 2026`. */
export function mesPorExtenso(mes: string): string {
  const MESES = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
  ]
  const [ano, m] = mes.split('-')
  const indice = Number(m) - 1
  return `${MESES[indice] ?? mes} de ${ano}`
}
